import React from "react";
import Grid from "@material-ui/core/Grid";

import { isHideTradingSection } from "../../../../utils";
import usePaymentPlanTrade from "./hooks/usePaymentPlanTrade";
import SavingsPlanTable from "./components/SavingsPlanTable";
import PortfolioHeader from "../PortfolioTradeV2/PortfolioHeader";
import {makeStyles} from "@material-ui/core";
import {TRANSACTION_TYPE_VALUES} from "../../../../constants";

const SAVING_PLAN_TRANSACTION_TYPE_NAMES = {
  create: "Sparpläne hinzufügen",
  edit: "Sparpläne bearbeiten",
  delete: "Sparpläne löschen",
}

const SavingsPlanTrade = ({
  portfolio,
  handlePortfolioChange,
  customer_id,
  defaults,
  updateDefaults,
  dataService,
  isVirtual,
  isCustomerApp,
}) => {
  const paymentPlanTransactionKey = TRANSACTION_TYPE_VALUES.SAVINGS_PLAN;

  const { transactions, groupedTransactions, onInstrumentsChange, getComponents, updatePlanDefaults } =
    usePaymentPlanTrade({
      portfolio,
      handlePortfolioChange,
      paymentPlanTransactionKey,
      updateDefaults,
    });

  return (
    <Grid container spacing={4}>
      {Object.keys(groupedTransactions).map((action) => (
        <Grid item xs={12}>
          <Grid container spacing={3} key={action}>
            <PaymentPlanSection
              action={action}
              paymentPlanTransactionKey={paymentPlanTransactionKey}
              portfolio={portfolio}
              transactions={transactions}
              groupedTransactions={groupedTransactions}
              getComponents={getComponents}
              onInstrumentsChange={onInstrumentsChange}
              customerId={customer_id}
              defaults={defaults}
              updateDefaults={updatePlanDefaults}
              dataService={dataService}
              isVirtual={isVirtual}
              isCustomerApp={isCustomerApp}
            />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  sectionHeader: {
    fontSize: 24,
  },
  sectionCounter: {
    fontSize: 12,
    color: '#838A93',
  }
}))

const PaymentPlanSection = ({
  action,
  paymentPlanTransactionKey,
  portfolio,
  transactions,
  groupedTransactions,
  getComponents,
  onInstrumentsChange,
  customerId,
  defaults,
  updateDefaults,
  dataService,
  isVirtual,
  isCustomerApp,
}) => {
  const classes = useStyles();
  const components = getComponents(action);
  const groupInstruments = groupedTransactions[action];

  if (isHideTradingSection(action, components, groupInstruments)) {
    return null;
  }

  return (
    <>
      <Grid item xs={12}>
        <span className={classes.sectionHeader}>
          <b>{SAVING_PLAN_TRANSACTION_TYPE_NAMES[action]}</b>
        </span>&nbsp;
        <span className={classes.sectionCounter}>
          ({`${groupInstruments.length} Produkt${groupInstruments.length === 1 ? "" : "e"}`})
        </span>
      </Grid>
      <Grid item xs={12}>
        <SavingsPlanTable
          action={action}
          paymentPlanTransactionKey={paymentPlanTransactionKey}
          portfolio={portfolio}
          portfolioComponents={components}
          allInstruments={transactions}
          groupInstruments={groupInstruments}
          onInstrumentsChange={onInstrumentsChange}
          customerId={customerId}
          defaults={defaults}
          updateDefaults={updateDefaults}
          dataService={dataService}
          isVirtual={isVirtual}
          isCustomerApp={isCustomerApp}
        />
      </Grid>
    </>
  );
};

export default SavingsPlanTrade;
